import {APIPromise, easasAxios, requestPromiseTypeWrapper} from "services/HttpService";
import {AxiosInstance} from "axios";
import {ScheduledTaskDTO} from "./model/airflow-task/ScheduledTaskDTO";
import {PythonCodeFileDTO} from "./model/airflow-task/PythonCodeFileDTO";

const API_SCOPE = "/scheduled-tasks";
const API_SCOPE_AIRFLOW = "/airflow";

const promise = requestPromiseTypeWrapper;

class ScheduledTasksApiDefinition {
    private httpClient: AxiosInstance;

    constructor() {
        console.log("ScheduledTasksApi obj created!")
        this.httpClient = easasAxios;
    }

    async getAirflowTaskConfig(dagId: string, taskId: string): APIPromise<ScheduledTaskDTO> {
        try {
            const {data} = await this.httpClient.get(`${API_SCOPE}/airflow/${dagId}/${taskId}/config`);
            return {data: new ScheduledTaskDTO(data)}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async saveAirflowTaskConfig(config: ScheduledTaskDTO, run: boolean = false): APIPromise<ScheduledTaskDTO> {
        return promise(this.httpClient.post(`${API_SCOPE}/airflow/config`, config, {params: {run: run}}), (data) => new ScheduledTaskDTO(data));
    }

    async getAirflowTaskHistories(dagId: string, taskId: string): APIPromise<IScheduledTaskHistoryDTO[]> {
        return promise<IScheduledTaskHistoryDTO[]>(this.httpClient.get(`${API_SCOPE}/airflow/${dagId}/${taskId}/histories`));
    }

    async uploadCodeFile(file: File): APIPromise<PythonCodeFileDTO> {
        const formData = new FormData();
        formData.append('file', file);

        return promise(this.httpClient.post(`${API_SCOPE}/code/upload`, formData));
    }

    async getAirflowTaskDataInfos(dagId: string): APIPromise<IAirflowTaskInfo[]> {
        return promise<IAirflowTaskInfo[]>(this.httpClient.get(`${API_SCOPE_AIRFLOW}/dag/${dagId}/task-infos`));
    }

    async getAirflowTaskJobData(dagId: string, taskId: string, refTime: number| string): APIPromise<any> {
        return promise<any>(this.httpClient.get(`${API_SCOPE}/airflow/${dagId}/${taskId}/test-data`, {params: {refTime: refTime}}));
    }

    async getAirflowGraphLink(dagId: string): APIPromise<string> {
        return promise(this.httpClient.get(`${API_SCOPE_AIRFLOW}/dag/${dagId}/graph-link`));
    }
}

export interface IAirflowTaskInfo {
    dagId: string;
    taskId: string;
    dagTitle: string;
    taskTitle: string;
}

export interface IScheduledTaskHistoryDTO {
    id: string;
    label: string;
    taskDagId: string;
    taskId: string;
    oldId: string;
    isAirflow: boolean;
    config: string;
    changeBy: string;
    changeByCompanyRef: string;
    changeByCompanyTitle: string;
    changeOn: string;
}

export const ScheduledTasksApi = new ScheduledTasksApiDefinition()
